import { createApp } from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
export default (app: ReturnType<typeof createApp>) => {
  app.use(VueViewer, {
    defaultOptions: {
      zIndex: 999999
    }
  })
}
